<template>
  <div>
    <Dialog 
      header="Forget Password Form" 
      :visible.sync="forgetPasswordDialog" 
      :style="{width: '500px'}" 
      :modal="true"
      class="p-fluid"
    >
      <div class="p-field p-grid">
        <label for="email" class="p-col-12"
          >Email Address*:</label
        >
        <div class="p-col-12">
          <InputText
            id="email"
            type="email"
            placeholder="Please enter your email"
            v-model="email"
            autofocus
          ></InputText>
        </div>
      </div>
      <div class="p-field p-grid">
        <span style="color: red;">{{ displayError }}</span>
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          @click="$emit('close')"
          autofocus
        />
        <ProgressSpinner 
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;" 
          strokeWidth="5" 
          fill="#EEEEEE" 
          animationDuration=".5s"
        />
        <Button 
          v-else
          @click="processForgetPassword()"
          label="Send Email"
          :disabled="!isValid(email)"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>

import UserService from "@/service/UserService";

export default {
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    resetDialog: {
      type: Number,
      required: false
    }
  },
  created() {
    this.setupComponent()
  },
  data: () => ({
    userService: new UserService(),
    sendingRequest: false,
    email: '',
    displayError: ''
  }),
  computed: {
    forgetPasswordDialog: {
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      },
      get() {
        return this.showDialog
      }
    }
  },
  watch: {
    resetDialog() {
      this.setupComponent()
    }
  },
  methods: {
    setupComponent() {
      this.email = ''
      this.sendingRequest = false
      this.displayError = ''
    },
    isValid(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email)
    },
    processForgetPassword() {
      this.sendingRequest = true

      this.userService
        .sendResetPasswordEmail({
          requestType: 'PASSWORD_RESET',
          email: this.email
        })
        .then(data => {
          this.displayError = ''
          this.sendingRequest = false
          this.$emit('close')
        })
        .catch(error => {
          this.sendingRequest = false

          

          if (error && error.response && error.response.data && error.response.data.error && error.response.data.error.message === "EMAIL_NOT_FOUND") {
            this.displayError = 'Email not found.'
          }
        })
    }
  }
}
</script>

<style>

</style>